import {
	type ScrollAreaProps as RadixScrollAreaProps,
	Root as RadixScrollAreaRoot,
	Viewport as RadixScrollAreaViewport,
	type ScrollAreaViewportProps
} from '@radix-ui/react-scroll-area'
import {
	type CSSProperties,
	forwardRef,
	type ReactNode,
	type RefAttributes
} from 'react'

type ScrollAreaProps = {
	children: ReactNode
	scrollbar: ReactNode
	viewportProps?: ScrollAreaViewportProps & RefAttributes<HTMLDivElement>
	overflowX?: CSSProperties['overflowX']
} & RadixScrollAreaProps

export const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
	({ children, scrollbar, viewportProps, overflowX, ...rest }, ref) => {
		return (
			<RadixScrollAreaRoot
				ref={ref}
				scrollHideDelay={500}
				style={{ overflowX }}
				{...rest}
			>
				<RadixScrollAreaViewport
					className='[&>div]:!block h-full'
					{...viewportProps}
				>
					{children}
				</RadixScrollAreaViewport>
				{scrollbar}
			</RadixScrollAreaRoot>
		)
	}
)

ScrollArea.displayName = 'ScrollArea'
